import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs'; // Subject allows communication between components
import { TopologyConfig } from 'src/app/_models/topology-list';

@Injectable({
  providedIn: 'root', // Provided in root to make it a singleton service
})
export class CommunicationService {

  private topologyIdSource = new BehaviorSubject<TopologyConfig | null>(null);
  topologyId$ = this.topologyIdSource.asObservable();

  setTopologyId(topologyId: TopologyConfig){
    this.topologyIdSource.next(topologyId);
  }

  private methodCalledSource = new Subject<void>(); // Observable source to trigger a method
  methodCalled$ = this.methodCalledSource.asObservable(); // Observable to listen for events

  // Method to trigger an event
  triggerMethod(param: any) {
    this.methodCalledSource.next(param); // Notify subscribers that the method was called
  }
}
